import React from "react";
import { useAppStore } from "../../store/appStore";
import styles from "./LoadingModal.module.css";

const LoadingModal = () => {
  const { isActive, message } = useAppStore((s) => s.loading);

  if (!isActive) return null;

  return (
    <div className={styles.loadingOverlay}>
      <div className={styles.loadingContainer}>
        <div className={styles.spinner}></div>
        <div className={styles.loadingText}>{message}</div>
      </div>
    </div>
  );
};

export default LoadingModal;
